/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import { useLocation } from 'react-router-dom'
import useTooltipControl from '../../../hooks/useTooltipControl'
import useRouterControl from '../../../hooks/useRouterControl'
import sendGaPush from '../../../utils/sendGaPush'
import Tooltip from '../../atoms/tooltip/tooltip'
import MenuChatButton from '../../molecules/menu-chat-button/menu-chat-button'
import { navMenuList } from './nav-menu-routes'
import {
	ServicesIcon,
	ServicesIconFill,
	ProfileIcon,
	ScheduleIcon,
	ProgramIcon,
	ScheduleIconFill,
	ProgramIconFill,
	ProfileIconFill
} from '../../atoms/icons'
import { CodesPermissions } from 'types/permissions'
import './nav-menu.scss'
import PermissionContainer from 'components/molecules/permission/permission'

const NavMenu = props => {
	const { chat, isParQPublicPath } = props

	const flagRegisterUserSmartFit = localStorage.getItem('registerUserSmartFit')
	const { listTooltip, showToolTip, handledSetListActive } = useTooltipControl({
		listToShow: [navMenuList.services, navMenuList.profile]
	})

	const { routerControl } = useRouterControl()
	const { pathname } = useLocation()
	const path = pathname || ''

	const listItems = [
		{
			label: 'Servicios',
			icon: <ServicesIcon />,
			activeIcon: <ServicesIconFill />,
			link: navMenuList.services,
			permission: CodesPermissions.DEFAULT
		},
		{
			label: 'Mi rutina',
			icon: <ScheduleIcon />,
			activeIcon: <ScheduleIconFill />,
			link: navMenuList.routine,
			permission: CodesPermissions.MI_RUTINA
		},
		{
			label: 'Programas',
			tag: <div className='tag-new-programs'>NUEVO</div>,
			icon: <ProgramIcon />,
			activeIcon: <ProgramIconFill />,
			link: navMenuList.program,
			permission: CodesPermissions.PROGRAMAS
		},
		{
			label: 'Mi perfil',
			icon: <ProfileIcon />,
			activeIcon: <ProfileIconFill />,
			link: navMenuList.profile,
			tooltipText: flagRegisterUserSmartFit
				? 'Aquí podrás administrar tu suscripción.'
				: 'Conoce más información sobre tu perfil.',
			tooltipStyle: {
				base: { top: '-105%', right: '2rem' },
				mark: { right: '1rem' }
			},
			permission: CodesPermissions.MI_PERFIL
		}
	]

	return (
		<>
			<div className='o-nav-menu'>
				{listItems.map(item => {
					return (
						<PermissionContainer
							key={`${item.link}_${item.label}`}
							permissionCode={item.permission}
						>
							<button
								className={'o-nav-menu-item ' + (path.includes(item.link) ? 'active ' : '')}
								onClick={() => {
									routerControl({ link: item.link })

									if (item?.label === 'Programas') {
										sendGaPush({
											category: 'SaludContinuarediseno',
											action: 'ClicMenuProgramas',
											event: 'clic_menu_programas',
											label: 'Programas'
										})
									} else {
										sendGaPush({
											category: 'SaludContinuarediseno',
											action: 'ClicMenu',
											label: item.label
										})
									}
								}}
							>
								{item.tooltipText && (
									<Tooltip
										isActive={showToolTip == item.link}
										setListActive={handledSetListActive}
										listActive={listTooltip}
										idTooltip={item.link}
										position='top'
										styles={item.tooltipStyle}
									>
										{item.tooltipText}
									</Tooltip>
								)}
								<div
									className={'o-nav-menu-icon ' + (showToolTip == item.link ? 'tool-active ' : '')}
								>
									{item?.tag ? item.tag : null}
									{path.includes(item.link) ? item.activeIcon : item.icon}
								</div>
								{item.label}
							</button>
						</PermissionContainer>
					)
				})}
			</div>
			{chat && !isParQPublicPath && <MenuChatButton />}
		</>
	)
}

export default NavMenu
